<template>
  <Error
    title="利用権限がありません"
    lead="このページにアクセスする権限がありません"
  >
    <template #default>
      確認後、再度アクセスしてください。
    </template>
  </Error>
</template>

<script>
import Error from '@/components/Error.vue'

export default {
  navbar: false,
  components: {
    Error
  },
  metaInfo() {
    return {
      title: '利用権限がありません',
      bodyAttrs: { class: 'error' }
    }
  }
}
</script>
